<template>
  <div class="container">
    <div class="jl-breadcrumbs">
      <ul>
        <li>锦鲤知识</li>
        <li>></li>
        <li class="jl-breadcrumbs-red">知识详情</li>
      </ul>
    </div>
    <div class="jl-tips-detail-wrapper">
      <div class="jl-tips-detail-box">
        <h2>{{ detail.title }}</h2>
        <div class="jl-tips-detail-box-content" v-html="detail.knowledge"></div>
        <div class="jl-tips-detail-box-time">发布时间：{{ detail.createDate }}</div>
      </div>
      <div class="jl-tips-detail-aside">
        <p>相关推荐</p>
        <ul>
          <li v-for="(item, index) in tipsData" :key="'know-re-'+index" @click="toDetail(item)">
            <div class="jl-tips-detail-aside-item-img">
              <img :src="item.imgUrl" alt />
            </div>
            <div class="jl-tips-detail-aside-item-info">
              <p>{{ item.title }}</p>
              <p>发布时间：{{ item.createDate }}</p>
            </div>
          </li>
        </ul>
        <!-- <button>查看更多</button> -->
      </div>
    </div>
  </div>
</template>

<script>
import { getKnowledgeDetail, getKnowledgeList } from "@/api/knowledge";
export default {
  name: "knowledgeDetail",
  data() {
    return {
      tipsData: [],
      detailId: "",
      detail: {},
      current: 1,
      display: 4,
      total: 1
    };
  },
  watch: {
    $route() {
      this.initData();
    }
  },
  methods: {
    initData() {
      this.detailId = this.$route.params.id;
      getKnowledgeDetail(this);
      getKnowledgeList(this);
    },
    toDetail(item) {
      this.$router.push({ name: "knowledgeDetail", params: { id: item.id } });
    }
  },
  created() {
    this.initData();
  }
};
</script>

<style lang="scss" scoped>
.jl-breadcrumbs {
  height: 44px;
  max-width: 1200px;
  margin: 0 auto;
  line-height: 44px;

  ul {
    &::after {
      content: "";
      clear: both;
    }
    li {
      float: left;
      margin-right: 5px;
      color: #666;
      font-size: 14px;

      &.jl-breadcrumbs-red {
        color: #e92b35;
      }
    }
  }
}
.jl-tips-detail-wrapper {
  max-width: 1200px;
  margin: 0 auto;
  padding-bottom: 120px;
  text-align: left;
  min-height: 900px;
  position: relative;

  .jl-tips-detail-box {
    vertical-align: top;
    width: 800px;
    position: relative;
    color: #333;

    h2 {
      text-align: left;
      width: 620px;
      display: inline-block;
      font-size: 28px;
      font-weight: 600;
      line-height: 36px;
      margin-top: 25px;
    }
    .jl-tips-detail-box-content {
      margin-top: 45px;
      font-size: 16px;
      line-height: 28px;
      color: #333;
      font-weight: 300;

      img {
        max-width: 100%;
      }
    }
    .jl-tips-detail-box-time {
      position: absolute;
      right: 0;
      top: 30px;
    }
  }
  .jl-tips-detail-aside {
    vertical-align: top;
    width: 376px;
    background: #f8f8fb;
    position: absolute;
    right: 0;
    top: 0;
    font-weight: 600;
    padding-bottom: 30px;

    p {
      color: #e70819;
      font-size: 20px;
      text-align: center;
      line-height: 20px;
      padding: 30px 0;
      border-bottom: 1px solid #e0e0e0;
    }
    ul {
      padding: 30px 30px 0;

      li {
        cursor: pointer;
        margin-bottom: 30px;
      }
      .jl-tips-detail-aside-item-img {
        width: 120px;
        height: 90px;
        display: inline-block;
        vertical-align: top;
        overflow: hidden;
        img {
          display: block;
          width: 100%;
          // height: 100%;
        }
      }
      .jl-tips-detail-aside-item-info {
        display: inline-block;
        vertical-align: top;
        width: 176px;
        height: 90px;
        overflow: hidden;
        margin-left: 15px;
        position: relative;

        p {
          padding: 0;
          color: #333;
          font-size: 16px;
          line-height: 20px;
          border: none;
          text-align: left;
          max-height: 40px;
          overflow: hidden;

          &:last-child {
            font-weight: 400;
            position: absolute;
            bottom: 5px;
            left: 0;
          }
        }
      }
    }
    button {
      display: block;
      width: 314px;
      height: 34px;
      line-height: 34px;
      font-size: 14px;
      margin: 0 auto;
      border: 1px solid #333;
      color: #333;
    }
  }
}
</style>
